import { useState } from 'react';
import { authAPI } from '../../../services/redwolfSdkAPI';
import useRequestRedwolfService from '../../common/hooks/useRequestRedwolfService';
import { useGoogleAnalytics } from '../../common/hooks/useGoogleAnalytics';
import * as Sentry from '@sentry/react';
import { useDispatch } from 'react-redux';
import { clearBrowserStorage } from '../../../store/userSlice';
import { reset } from '../../../store/paySlice';
import useTechnicalErrorMessage from '../../common/hooks/useTechnicalErrorMessage';
import { openNotification } from '../../../store/commonSlice';
import { notification } from '../../../utils/constants';
import { getToken } from '../../../utils/localStorage';

const useLogout = () => {
	const [requestRedwolfService] = useRequestRedwolfService();
	const [logGoogleAnalyticsEvent] = useGoogleAnalytics();
	const dispatch = useDispatch();
	const [showTechnicalErrorMessage] = useTechnicalErrorMessage();
	const [isSpinnerLoading, setIsSpinnerLoading] = useState(false);

	const token = getToken();

	const handleUserLogout = (redirection: any) => {
		setIsSpinnerLoading(true);

		const transaction = Sentry.startInactiveSpan({ name: 'LogOut' });

		return requestRedwolfService(authAPI.logout(token))
			.then(() => {
				setIsSpinnerLoading(false);
				dispatch(clearBrowserStorage());
				dispatch(reset());
				transaction && transaction.end();
				setTimeout(() => {
					if (redirection === 'home') {
						window.location.href = window.location.origin + '/en/home';
					} else if (redirection === 'login') {
						window.location.href = window.location.origin + '/en/account/login';
					} else if (redirection === 'password-reset') {
						window.location.href = window.location.origin + '/en/account/password-reset';
					}
				}, 500);

				if (redirection !== 'home') {
					logGoogleAnalyticsEvent('VIZIO_ACCOUNT_WEB_SIGN_OUT_SUCCESS');
					dispatch(
						openNotification({
							type: 'SUCCESS',
							heading: 'Success',
							body: notification.message.logoutSuccess
						})
					);
				}
				dispatch(
					openNotification({
						type: 'SUCCESS',
						heading: 'Success',
						body: notification.message.logoutSuccess
					})
				);
			})
			.catch((err: any) => {
				setIsSpinnerLoading(false);
				transaction && transaction.end();
				showTechnicalErrorMessage();
				Sentry.captureException(err);
			});
	};

	return [handleUserLogout];
};

export default useLogout;
